import { useState } from "react";
import { toast } from "sonner";
import { User, Package, MapPin, CreditCard } from "lucide-react";
import { PageHeader } from "../components/PageHeader";
import { Reveal } from "../components/Reveal";
import { useShop } from "../context/ShopContext";

const PERKS = [
  { icon: Package, label: "Order history & live status" },
  { icon: MapPin, label: "Saved addresses, faster checkout" },
  { icon: CreditCard, label: "Stored payment via Shopify" },
  { icon: User, label: "Run Club profile & early access" },
];

export default function Account() {
  const { connected } = useShop();
  const [email, setEmail] = useState("");

  const submit = (e) => {
    e.preventDefault();
    toast.info(
      connected
        ? "Customer accounts activate with Shopify customer account configuration — coming online soon."
        : "Accounts unlock when the Shopify store is connected."
    );
  };

  return (
    <div>
      <PageHeader
        eyebrow="Your account"
        title="Members area"
        description="Sign in with your Shopify store account to see orders, tracking and saved details. Powered entirely by Shopify customer accounts."
      />
      <div className="grid gap-10 px-5 py-12 sm:px-10 lg:grid-cols-2 lg:px-16">
        <Reveal>
          <form
            onSubmit={submit}
            data-testid="account-signin-form"
            className="border border-border p-8"
          >
            <h2 className="font-display text-xl font-bold uppercase tracking-tight">
              Sign in
            </h2>
            <p className="mt-2 text-sm text-muted-foreground">
              One-time code sent to your email — no passwords.
            </p>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="EMAIL ADDRESS"
              data-testid="account-email-input"
              className="mt-6 w-full border-b border-border bg-transparent py-3.5 font-mono text-xs uppercase tracking-[0.2em] placeholder:text-muted-foreground focus:border-signal focus:outline-none"
            />
            <button
              type="submit"
              data-testid="account-signin-button"
              className="mt-8 w-full bg-signal py-4 font-mono text-xs font-bold uppercase tracking-[0.25em] text-white transition-colors hover:bg-signal/90"
            >
              Send sign-in code
            </button>
            <p className="mt-4 font-mono text-[10px] uppercase tracking-[0.15em] text-muted-foreground">
              {connected
                ? "Customer accounts are being configured on this store"
                : "Activates when the Shopify store is connected"}
            </p>
          </form>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="border border-border p-8">
            <h2 className="font-display text-xl font-bold uppercase tracking-tight">
              Why join
            </h2>
            <ul className="mt-6 space-y-5">
              {PERKS.map((p) => (
                <li key={p.label} className="flex items-center gap-4">
                  <span className="border border-border p-2.5 text-signal">
                    <p.icon className="h-4 w-4" />
                  </span>
                  <span className="text-sm text-foreground/90">{p.label}</span>
                </li>
              ))}
            </ul>
          </div>
        </Reveal>
      </div>
    </div>
  );
}
